import React from "react";
import { CompanyTenK } from "../../../company";
import { Link } from "react-router-dom";

interface Props {
  tenK: CompanyTenK;
}

const TenKFinderItem = ({ tenK }: Props) => {
  const filingDate = new Date(tenK.filingDate).getFullYear();
  return (
    <a
      href={tenK.link}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center p-4 text-md text-white bg-lightGreen rounded-md"
    >
      10K - {tenK.symbol} - {filingDate}
    </a>
  );
};

export default TenKFinderItem;
